export class NotImplementedError extends Error {
    constructor(message = 'This functionality is not implemented yet.', feature_name = null) {
        if (feature_name) {
            message = `${feature_name} is not implemented yet.`;
        }
        super(message); // Pass message to the base Error class
        this.name = 'NotImplementedError'; // Set error name
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, NotImplementedError);
        }
    }
}